var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "pdf-icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h64v64H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pdf-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.67 56c-1.245 0-2.278-.41-3.1-1.232-.822-.823-1.234-1.857-1.234-3.101V12.333c0-1.244.412-2.278 1.235-3.101C15.39 8.411 16.425 8 17.669 8h21l12 12v31.667c0 1.244-.41 2.278-1.232 3.101-.823.821-1.857 1.232-3.101 1.232H17.669zm19.666-34.667V10.667H17.669c-.444 0-.833.167-1.165.501-.334.332-.501.72-.501 1.165v39.334c0 .444.167.833.5 1.165.333.334.722.501 1.166.501h28.667c.444 0 .833-.167 1.165-.501.335-.332.502-.72.502-1.165V21.333H37.336z",
    fill: "#019ABC"
  }))));
}
export default SvgPdfIcon;